<h1 i18n>The candidate has completed the exam.</h1>
